'use strict';

var cssUtils = require('../core/cssUtils');

var fragment = require('../core/fragment');

var _ = require('lodash');

var CONSTANTS = require('./constants');

var GOOGLE_FONT_SERVICE_URL = '//fonts.googleapis.com/css?family=';
var UPLOADED_FONT_MASK = 'wfont_[0-9a-f]{6}_[0-9a-f]{32}';
var SHORTY_FONT_MASK = 'wf_[0-9a-f]{25}';
var UPLOADED_FONT_TEST = new RegExp("^" + UPLOADED_FONT_MASK);
var UPLOADED_FONT_MATCH = new RegExp(UPLOADED_FONT_MASK + "|" + SHORTY_FONT_MASK, 'g');
var TEXT_THEMES_MAP_KEY = 'font';

var createFontUtils = function createFontUtils(fontsMetadata) {
  var parseFontStr = cssUtils.parseFontStr,
      fromTextThemeToFontStyle = cssUtils.fromTextThemeToFontStyle;

  function getFontsUrlWithParams(fontNamesObject, documentType, characterSets) {
    var fontsFamiliesArray = _.isArray(fontNamesObject) ? fontNamesObject : _.keys(fontNamesObject);
    var query = getFontsQuery(fontsFamiliesArray, documentType, characterSets);

    if (query) {
      return GOOGLE_FONT_SERVICE_URL + query;
    }

    return '';
  }

  function getFontsQuery(fontsFamiliesArray, documentType, characterSets) {
    var fontQuery = '';
    var permissions = getFontsPermissions(documentType);

    _.forEach(fontsFamiliesArray, function (fontFamily) {
      var font = fontsMetadata[fontFamily];

      if (font && font.cdnName && _.includes(permissions, font.permissions)) {
        fontQuery += font.cdnName + ":n,b,i,bi|";
      }
    });

    if (fontQuery === '') {
      return null;
    }

    if (characterSets) {
      fontQuery += "&subset=" + characterSets.join(',');
    }

    return fontQuery;
  }

  function getFontsPermissions(documentType) {
    var permissions = ['all', 'legacy'];

    if (documentType === 'WixSite') {
      permissions.push('studio');
    }

    return permissions;
  }

  function getWixStoredFontsCssUrlsWithParams(baseUrl, characterSets, altBaseUrl) {
    if (altBaseUrl && /localhost|127.0.0.\d/.test(baseUrl)) {
      baseUrl = altBaseUrl;
    }

    baseUrl = baseUrl.replace(/^http:/, '');
    var fontsCssBaseUrl = baseUrl.replace(/\/$/, '') + "/static/css/user-site-fonts/";
    return _.map(characterSets, function (cs) {
      return fontsCssBaseUrl + cs + ".css";
    });
  }

  function parseStyleFont(fontStyleName, themeFonts, themeColors) {
    if (themeFonts[fontStyleName]) {
      var fontObject = parseStringFont(themeFonts[fontStyleName]);
      return parseThemeFontColor(fontObject, themeColors);
    }

    return parseStringFont(fontStyleName);
  }

  function parseStyleTextTheme(fontStyleName, textThemes, themeColors) {
    var textTheme = textThemes[fontStyleName] || textThemes;
    var fontObj = fromTextThemeToFontStyle(textTheme);
    fontObj.fontWithFallbacks = getFontFamilyWithFallbacks(fontObj.family);
    fontObj.cssColor = textThemeToColor(textTheme, themeColors);
    return fontObj;
  }

  function parseStringFont(fontValue) {
    var fontObject = parseFontStr(fontValue);
    fontObject.fontWithFallbacks = getFontFamilyWithFallbacks(fontObject.family);
    return fontObject;
  }

  function getFontFamilyWithFallbacks(fontName) {
    var cleanFontName = fontName.replace(/\+/g, ' ').toLowerCase();
    var font = fontsMetadata[cleanFontName];
    var fontFamily = font && font.fontFamily;
    var fallbacks;

    if (font) {
      fallbacks = fontFamily;

      if (font.fallbacks !== '') {
        fallbacks += "," + font.fallbacks;
      }

      fallbacks += "," + font.genericFamily;
    } else {
      fallbacks = fontName;
    }

    return formatFallbackList(fallbacks);
  }

  function formatFallbackList(fallbacks) {
    //surround fonts with quotes if font name contains spaces or non-latin chars
    return _(fallbacks).split(',').invokeMap('replace', /.*[^\w\d\-].*/, '"$&"').join(',');
  }

  function parseThemeFontColor(fontObject, themeColors) {
    var fontColor = fontObject.color && fontObject.color.match(/{([^}]+)}/);

    if (themeColors && fontColor && themeColors[fontColor[1]]) {
      fontObject.cssColor = themeColors[fontColor[1]];
    } else {
      fontObject.cssColor = fontObject.color;
    }

    return fontObject;
  }

  function getFontFamily(fontStr) {
    return fontStr.split(' ')[4];
  }

  function fontToCSSWithColor(font, themeColors) {
    var fontVal = getFontVal(font);
    var fontCss = getFontCSSFromFontString(fontVal);
    var colorCss = getColorCSSFromFontString(fontVal, themeColors);
    return fontCss + colorCss;
  }
  /**
   * @param themeFonts: {font_0: 'fontString', font_1: 'fontString'}
   * @param themeColors
   * @returns ".font_0: {"font: 'normal normal normal 45px/1.4em Open+Sans; color: #123456;} "
   */


  function getThemeFontsCss(themeFonts, themeColors) {
    var result = '';

    _.forEach(themeFonts, function (fontString, fontIndex) {
      result += ".font_" + fontIndex + " {font: " + fontToCSSWithColor(fontString, themeColors) + "} \n";
    });

    return result;
  }
  /**
   * @param {Object[]|Object} textThemes
   * @returns {Object}
   */


  function getTextThemesMap(textThemes) {
    var textThemesMap = {};

    _.forEach(textThemes, function (textTheme, index) {
      var key = TEXT_THEMES_MAP_KEY + "_" + index;
      textThemesMap[key] = textTheme;
    });

    return textThemesMap;
  }
  /**
   * @param {Object} textTheme
   * @return {string}
   */


  function textThemeToCSSLetterSpacing(textTheme) {
    var letterSpacing = textTheme.letterSpacing;
    return letterSpacing ? "letter-spacing: " + letterSpacing + ";" : '';
  }
  /**
   * @param {Object} textTheme
   * @return {string}
   */


  function textThemeToFont(textTheme) {
    var DEFAULT_VALUE = 'normal';
    var fontSize = textTheme.fontSize,
        fontFamily = textTheme.fontFamily,
        lineHeight = textTheme.lineHeight,
        fontStyle = textTheme.fontStyle,
        fontWeight = textTheme.fontWeight,
        fontVariant = textTheme.fontVariant;
    var fontSizeAndLineHeight = lineHeight ? fontSize + "/" + lineHeight : fontSize;
    return [fontStyle || DEFAULT_VALUE, fontVariant || DEFAULT_VALUE, fontWeight || DEFAULT_VALUE, fontSizeAndLineHeight, fontFamily].join(' ');
  }
  /**
   * @param {Object} textTheme
   * @return {string}
   */


  function textThemeToCSSFont(textTheme) {
    var fontFamily = getFullFontFamily(textTheme.fontFamily);
    textTheme = Object.assign({}, textTheme, {
      fontFamily: fontFamily
    });
    var fontString = textThemeToFont(textTheme);
    return "font: " + fontString + ";";
  }
  /**
   * @param {Object} textTheme
   * @param {string[]} themeColors
   * @return {string}
   */


  function textThemeToColor(textTheme, themeColors) {
    var color = textTheme.color;
    var colorParts = color.match(/{color_(\d+)}/);

    if (colorParts) {
      var colorIndexInTheme = colorParts[1];

      if (Array.isArray(themeColors)) {
        color = themeColors[colorIndexInTheme];
      } else {
        var themeColorsValues = Object.values(themeColors);
        color = themeColorsValues[colorIndexInTheme];
      }
    }

    return color.indexOf('#') === 0 ? color : "rgba(" + color + ")";
  }
  /**
   * @param {Object} textTheme
   * @param {string[]} themeColors
   * @return {string}
   */


  function textThemeToCSSColor(textTheme, themeColors) {
    if (!textTheme.color) {
      return '';
    }

    var color = textThemeToColor(textTheme, themeColors);
    return "color: " + color + ";";
  }
  /**
   * @param {Object} textTheme
   * @param {string[]} themeColors
   * @return {string}
   */


  function textThemeToCSS(textTheme, themeColors) {
    var font = textThemeToCSSFont(textTheme);
    var color = textThemeToCSSColor(textTheme, themeColors);
    var letterSpacing = textThemeToCSSLetterSpacing(textTheme);
    return [font, color, letterSpacing].join(' ');
  }
  /**
   * @param {Object[]} textThemes
   * @param {string[]} themeColors
   * @return {string}
   */


  function getTextThemesCss(textThemes, themeColors) {
    var textThemesMap = getTextThemesMap(textThemes);
    var result = '';

    _.forEach(textThemesMap, function (textTheme, className) {
      var css = textThemeToCSS(textTheme, themeColors);
      result += "." + className + " {" + css + "}\n";
    });

    return result;
  }
  /**
   * @param {Object} textTheme
   * @return {string}
   */


  function textThemeToFontString(textTheme) {
    var color = textTheme.color;
    var font = textThemeToFont(textTheme);
    return [font, color].join(' ');
  }
  /**
   * @param {string} fontString
   * @return {Object}
   */


  function fontStringToTextTheme(fontString) {
    var _fontString$split = fontString.split(' '),
        fontStyle = _fontString$split[0],
        fontVariant = _fontString$split[1],
        fontWeight = _fontString$split[2],
        fontSizeLineHeight = _fontString$split[3],
        fontFamily = _fontString$split[4],
        color = _fontString$split[5];

    var _fontSizeLineHeight$s = fontSizeLineHeight.split('/'),
        fontSize = _fontSizeLineHeight$s[0],
        lineHeight = _fontSizeLineHeight$s[1];

    return {
      fontStyle: fontStyle,
      fontWeight: fontWeight,
      fontVariant: fontVariant,
      fontFamily: fontFamily,
      fontSize: fontSize,
      lineHeight: lineHeight,
      color: color,
      letterSpacing: '0em'
    };
  }

  function getFontVal(fontString, themeData) {
    if (_.startsWith(fontString, 'font_')) {
      var fontParts = fontString.split('font_');

      if (fontParts.length === 2) {
        return themeData.font[fontParts[1]];
      }
    }

    return fontString;
  }

  function getFontsByPermissionToFontsList(documentType) {
    var permissions = getFontsPermissions(documentType);

    var langs = _.reduce(fontsMetadata, function (res, value, key) {
      var fontCharacterSets = value.characterSets;

      if (_.includes(permissions, value.permissions)) {
        value.cssFontFamily = getFontFamilyWithFallbacks(key);

        _.forEach(fontCharacterSets, function (charSet) {
          if (!res[charSet]) {
            res[charSet] = [];
          }

          res[charSet].push(value);
        });
      }

      return res;
    }, {});

    _.forOwn(langs, function (fontList, charSet) {
      langs[charSet] = _.sortBy(fontList, ['displayName']);
    });

    return langs;
  }

  function getCurrentSelectablefontsWithParams(documentType, characterSets) {
    var languagesFontsLists = getFontsByPermissionToFontsList(documentType);
    return _(CONSTANTS.POSSIBLE_CHARACTERS_SETS).intersection(characterSets).map(function (lang) {
      return {
        lang: lang,
        fonts: languagesFontsLists[lang]
      };
    }).value();
  }
  /**
   * Gets font items for the font family selector drop down
   * @param {Object} fontsByLang - getCurrentSelectablefontsWithParams output
   * @returns {Object} Font items in font family selector drop down format
   */


  function getFontsDropDownItems(fontsByLang) {
    var FONT_GROUPS = CONSTANTS.FONT_GROUPS,
        LANG_TO_EXAMPLE_KEY = CONSTANTS.LANG_TO_EXAMPLE_KEY,
        HELVETICA_FALLBACK = CONSTANTS.HELVETICA_FALLBACK;
    var fontItems = [];

    _.forEach(fontsByLang, function (_ref) {
      var fonts = _ref.fonts,
          lang = _ref.lang;
      var items = [];

      _.forEach(fonts, function (font) {
        if (font.permissions === 'legacy') {
          return;
        }

        items.push({
          label: font.displayName,
          value: font.fontFamily,
          example: LANG_TO_EXAMPLE_KEY[lang],
          cssFontFamily: font.cssFontFamily + "," + HELVETICA_FALLBACK
        });
      });

      fontItems.push({
        groupName: FONT_GROUPS[lang],
        items: items
      });
    });

    return fontItems;
  }

  function getFontFallback(fontFamily) {
    var cleanFontName = fontFamily.replace(/\+/g, ' ').toLowerCase();
    var fontMeta = fontsMetadata[cleanFontName];

    if (fontMeta) {
      var fallback = fontMeta.fallbacks;

      if (fallback) {
        fallback += ',';
      }

      fallback += fontMeta.genericFamily;
      return fallback;
    }

    return '';
  }

  function getFontCSSFromFontString(fontVal) {
    var font = fontVal;

    if (_.includes(font, '#')) {
      font = font.slice(0, font.indexOf('#'));
    }

    font = font.replace(/\{color_\d+\}/, '');
    var fontFamily = getFontFamily(font);
    var fullFontFamily = getFullFontFamily(fontFamily);
    var childFont = font.replace(fontFamily, fullFontFamily);
    return childFont + ";";
  }

  function getFullFontFamily(fontFamily) {
    var fullFontFamily = fontFamily;
    var fallback = getFontFallback(fontFamily);

    if (fallback) {
      fullFontFamily = fullFontFamily + "," + fallback;
    } //surround fonts with quotes if font name contains spaces or non-latin chars


    fullFontFamily = fullFontFamily.replace(/[^,]*[^\w,\d\-][^,]*/g, function (fontFamilyStr) {
      return "'" + fontFamilyStr.replace(/\+/g, ' ') + "'";
    });
    return fullFontFamily;
  }

  function getColorCSSFromFontString(fullFontString, themeColors) {
    var colorParts = fullFontString.match(/{color_(\d+)}/);

    if (!colorParts) {
      var colorFromFontString = fullFontString.match(/#[A-Z0-9]{3,6}/);

      if (colorFromFontString) {
        return "color:" + colorFromFontString[0] + ";";
      }

      return '';
    }

    var colorIndexInTheme = colorParts[1];
    var colorFromTheme = themeColors[colorIndexInTheme];

    if (colorFromTheme.indexOf('#') === 0) {
      return "color:" + colorFromTheme + ";";
    }

    return "color:rgba(" + colorFromTheme + ");";
  }

  function getFontFamilyPermissions(fontFamily) {
    var fontDef = _.find(fontsMetadata, {
      fontFamily: fontFamily
    });

    return fontDef && fontDef.permissions;
  }

  function getFontsMetaData() {
    return fontsMetadata;
  }

  function collectFontsFromTextDataArray(textHtml, _temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        _ref2$onlyUploaded = _ref2.onlyUploaded,
        onlyUploaded = _ref2$onlyUploaded === void 0 ? false : _ref2$onlyUploaded;

    if (!textHtml) {
      return [];
    }

    if (onlyUploaded) {
      return textHtml.match(UPLOADED_FONT_MATCH);
    }

    var doc = new fragment.DOMParser().parseFromString(textHtml, 'text/html');
    return _(doc.querySelectorAll('*')).toArray().map(function (el) {
      return _.get(el, ['style', 'font-family']);
    }).compact().invokeMap('trim').value();
  }

  function isUploadedFontFamily(fontFamilyStr) {
    if (_.isNil(fontFamilyStr) || _.isEmpty(fontFamilyStr)) {
      return false;
    }

    var fontName = _.head(fontFamilyStr.split(','));

    return UPLOADED_FONT_TEST.test(fontName);
  }

  function getUploadedId(uploadedFonStr) {
    return isUploadedFontFamily(uploadedFonStr) ? uploadedFonStr.replace(CONSTANTS.LONG_UPLOADED_FONT_PREFIX, '').trim() : null;
  }

  function getUploadedFontFaceStyles(fontFamiliesArr, mediaRootUrl) {
    var fixedMediaRootUrl = fixMediaRootUrl(mediaRootUrl);
    return _(fontFamiliesArr).filter(isUploadedFontFamily).reduce(function (accm, font) {
      return accm + getUploadFontFace(font, fixedMediaRootUrl);
    }, '');
  }

  function fixMediaRootUrl(mediaRootUrl) {
    return _.startsWith(mediaRootUrl, 'http://') ? mediaRootUrl.replace('http://', 'https://') : mediaRootUrl;
  }

  function getUploadFontFace(font, mediaRootUrl) {
    var fontName = _.head(font.split(','));

    var fontId = getUploadedId(fontName);
    var shortFontName = getShortUploadedFontFamily(fontName);
    var fontFaceString = "@font-face {\nfont-family: " + shortFontName + ";\nsrc: url(\"" + mediaRootUrl + "ufonts/" + fontId + "/woff2/file.woff2\") format(\"woff2\"),\nurl(\"" + mediaRootUrl + "ufonts/" + fontId + "/woff/file.woff\") format(\"woff\"),\nurl(\"" + mediaRootUrl + "ufonts/" + fontId + "/ttf/file.ttf\") format(\"ttf\");\n}\n";
    return fontFaceString;
  }

  function getShortUploadedFontFamily(font) {
    return "wf_" + /^wfont_[0-9a-f]{6}_([0-9a-f]{25})[0-9a-f]{7}/.exec(font)[1];
  }

  function getMetadata(fontNames) {
    return _.compact(_.map(fontNames, function (fontName) {
      return getFontsMetaData()[fontName];
    }));
  }

  function getFontFamilyByStyleId(generalThemeData, stylesId) {
    var fontStyles = generalThemeData.font;
    var fontIndex = parseInt(stylesId.substring(stylesId.indexOf('_') + 1), 10);
    var fontStyleString = fontStyles[fontIndex];
    var fontFamily = '';

    if (fontStyleString) {
      fontFamily = parseFontStr(fontStyleString).family.toLowerCase();
    }

    return fontFamily;
  }

  function getUploadedFontValue(fontId) {
    var fontName = "" + (CONSTANTS.LONG_UPLOADED_FONT_PREFIX + fontId);
    var fontShortName = getShortUploadedFontFamily(fontName);
    return [fontName, fontShortName].join(',');
  }

  return {
    parseFontStr: parseFontStr,
    getFontsUrlWithParams: getFontsUrlWithParams,
    getWixStoredFontsCssUrlsWithParams: getWixStoredFontsCssUrlsWithParams,
    parseStyleFont: parseStyleFont,
    getFontFamilyWithFallbacks: getFontFamilyWithFallbacks,
    getFontFamily: getFontFamily,
    getCurrentSelectablefontsWithParams: getCurrentSelectablefontsWithParams,
    getFontsDropDownItems: getFontsDropDownItems,
    fontToCSSWithColor: fontToCSSWithColor,
    getThemeFontsCss: getThemeFontsCss,
    getFontFallback: getFontFallback,
    getFontFamilyPermissions: getFontFamilyPermissions,
    getFontsMetaData: getFontsMetaData,
    collectFontsFromTextDataArray: collectFontsFromTextDataArray,
    isUploadedFontFamily: isUploadedFontFamily,
    getUploadedId: getUploadedId,
    getUploadedFontFaceStyles: getUploadedFontFaceStyles,
    getMetadata: getMetadata,
    getFontFamilyByStyleId: getFontFamilyByStyleId,
    getUploadedFontValue: getUploadedFontValue,
    getShortUploadedFontFamily: getShortUploadedFontFamily,
    getTextThemesCss: getTextThemesCss,
    getTextThemesMap: getTextThemesMap,
    textThemeToFontString: textThemeToFontString,
    fontStringToTextTheme: fontStringToTextTheme,
    textThemeToColor: textThemeToColor,
    parseStyleTextTheme: parseStyleTextTheme
  };
};

module.exports = createFontUtils;
//# sourceMappingURL=fontUtils.js.map